import { publish } from '@ltvco/refresh-lib';
import { AppConstants } from '@ltvco/refresh-lib/ctx';
import { Box } from '@ltvco/refresh-lib/theme';
import {
  GlobalReportAttachmentsCTA,
  GlobalAttachmentsSection,
  ReportAttachmentsHeader,
  type RecentReportSerialized,
} from '@ltvco/refresh-lib/v2';
import { useFeatureIsOn } from '@ltvco/refresh-lib/vendors';
import { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export function ReportAttachments() {
  const {
    featureFlags: { hasReportAttachmentsEnabled },
  } = useContext(AppConstants);
  const isAttachmentsEnabled =
    useFeatureIsOn('UPS-1150') && hasReportAttachmentsEnabled;
  const navigate = useNavigate();
  const [selectedPermalink, setSelectedPermalink] = useState<
    string | undefined
  >(undefined);
  const [selectedReportType, setSelectedReportType] = useState<
    string | undefined
  >(undefined);
  const [autoOpenUpload, setAutoOpenUpload] = useState(false);

  const handleSelectReport = (report: RecentReportSerialized) => {
    setSelectedPermalink(report.id);
    setSelectedReportType(report.reportTypeFormatted.toLowerCase());
    setAutoOpenUpload(true);
  };

  if (!isAttachmentsEnabled) {
    navigate('/dashboard', { replace: true });
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      rowGap={2.5}
      paddingX={{ xs: 2.5, sm: 0 }}
    >
      <ReportAttachmentsHeader spacious scope="global" entityType="Report" />
      <GlobalReportAttachmentsCTA
        permalink={selectedPermalink}
        autoOpenUpload={autoOpenUpload}
        onUploadModalClose={() => setAutoOpenUpload(false)}
        reportType={selectedReportType}
        onOpenSearch={() => publish('openPersonSearch')}
        onSelectReport={handleSelectReport}
      />
      <GlobalAttachmentsSection />
    </Box>
  );
}
